<script setup>
import { onMounted, ref } from 'vue';
import { useCustomerStore } from '@/stores/customer';
import { useAccountDetailsStore } from '@/stores/account_details'
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';
import { useThemeStore } from '@/stores/themes';

const customerStore = useCustomerStore();
const accountDetailsStore = useAccountDetailsStore();
const betslip_changes = ref('');
const platformConfigurationStore = usePlatformConfigurationStore();
const themeStore = useThemeStore();


const toggleBetslipChangesPreferences = (betslip_changes_option) => {
	const payload = { betslip_changes: 'always_ask'};
	if (betslip_changes.value != betslip_changes_option) payload.betslip_changes = betslip_changes_option;

	accountDetailsStore.updateCustomerOdds(payload).then( () => {
		betslip_changes.value = payload.betslip_changes
	})
}

onMounted(() => {
	if (customerStore.isLoggedIn) betslip_changes.value = customerStore.getCustomer.betslip_changes;
	else betslip_changes.value = 'always_ask'
})

</script>

<template>
	<div class="content-main">
		<div class="title-main">
				<svg class="normal-img"
					xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
					style="shape-rendering:geometricPrecision; stroke: var(--white); width: 30px; height: 30px; margin-top: 6px; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
					viewBox="0 0 34 34" xmlns:xlink="http://www.w3.org/1999/xlink">
					<use :xlink:href="'/assets/icons/settings-ico.svg#svg3108'"/>
				</svg>
			<h3>{{ $t('general.settings') }}</h3>
		</div>

		<div class="radio-main-outer" >
			<div class="radio-main-inner" v-if="customerStore.isLoggedIn">
				<form>
					<div  class="switch-outer">
						<label class="switch" @click="toggleBetslipChangesPreferences('accept_any_odds')">
							<input :checked="betslip_changes == 'accept_any_odds'" type="checkbox">
							<span class="switch-slider round"></span>
						</label>
					</div>
				</form>
				<p>{{ $t('account.account_preferences.accept_any_odds') }}</p>
			</div>

			<div class="radio-main-inner" v-if="customerStore.isLoggedIn">
				<form>
					<div  class="switch-outer">
						<label class="switch" @click="toggleBetslipChangesPreferences('accept_higher_odds')">
							<input :checked="betslip_changes == 'accept_higher_odds'" type="checkbox">
							<span class="switch-slider round"></span>
						</label>
					</div>
				</form>
				<p>{{ $t('account.account_preferences.accept_higher_odds') }}</p>
			</div>

			<div v-if="platformConfigurationStore.isMultiThemeSupportEnabled && themeStore.themes.length > 1" class="radio-main-inner">
				<p style="text-wrap: nowrap;">{{ $t('general.select_theme') }}</p>
				<div class="select-icon-wrapper">
					<select class="dropdown" v-model="themeStore.selected_theme" @change="themeStore.enableTheme(themeStore.selected_theme)" >
						<option v-for="theme in themeStore.getThemeTitles" :key="theme.id" :value="theme.id">{{ theme.name }}</option>
					</select>
					<span class="custom-select-arrow">&#x2304;</span>
				</div>
			</div>

		</div>
	</div>
</template>

<style scoped>
.dropdown {
	padding: 8px 10px;
	background-color: var(--light-dark);
	border-radius: 3px;
	width: -webkit-fill-available;
	font-size: 14px;
	font-weight: 300;
	color: var(--white);
}
.select-icon-wrapper {
	position: relative;
	display: inline-block;
	overflow: hidden;
	/* width: 100%; */
}

.select-icon-wrapper select {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	background-image: none !important;
	padding-right: 2.5em !important;
}

.select-icon-wrapper .custom-select-arrow {
	content: '\2304';
	position: absolute;
	top: 35%;
	right: 0.8em;
	transform: translateY(-50%);
	color: var(--white);
	pointer-events: none;
	z-index: 1;
}

html[dir="rtl"] .select-icon-wrapper .custom-select-arrow {
	right: unset;
	left: 0.8em;
}
</style>